import DopplerRadarContent from '../../features/DopplerRadar/components/DopplerRadarContent/DopplerRadarContent.jsx';
import { DOPPLER_WIDGET_ACCESSIBLE_NAME } from '../../features/DopplerRadar/config/dopplerRadar.config.js';
import { getDopplerRadarWidgetLayoutConfig } from './config/dopplerRadarWidget.config.js';

const DopplerRadarWidget = ({ layout }) => {
  const widgetLayoutConfig = getDopplerRadarWidgetLayoutConfig(layout);

  return (
    <DopplerRadarContent
      accessibleName={DOPPLER_WIDGET_ACCESSIBLE_NAME}
      compact
      useSinglePanelCompactControls={widgetLayoutConfig.useSinglePanelCompactControls}
    />
  );
};

export default DopplerRadarWidget;
